import "./Css/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./Screens/LandingPage";
import ScrollToTop from "react-scroll-to-top";
import { ArrowUpward, KeyboardArrowUp } from "@mui/icons-material";

const App = () => {
  return (
    <BrowserRouter>

      {/* Scroll Button */}
      <ScrollToTop
        smooth
        component={<KeyboardArrowUp />}
        style={{
          backgroundColor: `linear-gradient(145deg, #1f4060, #173c5c) !important`,
          borderRadius: "20%",
          boxShadow: '0px !important',
          color: "#ffff !important",
          right: 20,
          bottom: 20
        }}
      />

      <Routes>
        <Route path="/" element={<LandingPage />} />
      </Routes>

    </BrowserRouter>
  );
};

export default App;
